<script setup lang="ts">
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/features/auth/stores/auth.store'
import { useToast } from '@/shared/composables/use-toast'
import FormBusyHost from '@/shared/components/FormBusyHost.vue'
import HrToastHost from '@/shared/components/HrToastHost.vue'
import NetworkOfflineBanner from '@/shared/components/NetworkOfflineBanner.vue'
import AppUpdateBanner from '@/shared/components/AppUpdateBanner.vue'

const auth = useAuthStore()
auth.initStorageSync()

const { t } = useI18n()
const toast = useToast()

onMounted(() => {
  // Check if user was blocked from a menu
  const blockedRoute = sessionStorage.getItem('menuBlockedRoute')
  if (blockedRoute) {
    sessionStorage.removeItem('menuBlockedRoute')
    toast.error(t('common.menuAccessDenied'))
  }
})
</script>

<template>
  <NetworkOfflineBanner />
  <AppUpdateBanner />
  <router-view />
  <FormBusyHost />
  <HrToastHost />
</template>
